<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4>Proyeccion {{this.id}}</h4>
                <table class="table align-items-center border">
                    <thead class="thead-blue">
                        <tr>
                            <th class="text-center">EMPRESA</th>
                            <th class="text-center">PERIODO</th>
                            <th class="text-center">Guardar Cambios</th>
                        </tr>
                    </thead>
                    <tr>
                        <td class="text-center">{{proyeccion?proyeccion.empresa.nombre:''}}</td>
                        <td class="text-center">{{proyeccion?proyeccion.anio:''}}</td>
                        <td class="text-center">
                            <button class="btn thead-green1 btn-sm" @click="agregar">
                                <i class="fas fa-plus"></i> Guardar
                            </button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="alert">
                    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                    <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                    <span class="alert-text" v-for="(m,index) in mensaje" :key="index"> <strong>{{`${m},`}}</strong></span>
                    
                    <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4>DETALLE DE PROYECCIÓN EN TONELADAS</h4>
                </div>
                <div class="row">
                    <button class="btn btn-primary btn-sm float-left" @click="agregar">
                        <i class="fas fa-plus"></i> Agregar
                    </button>
                </div>
                <div class="row table-responsive mt-2">
                    <table class="table align-items-center border">
                        <thead class="thead-skyblue2">
                            <tr>
                                <th class="text-center">MATERIA PRIMA</th>
                                <th class="text-center" v-for="m in meses" :key="m">{{m}}</th>
                                <th class="text-center">Guardar</th>
                                <th class="text-center">Eliminar</th>
                                
                            </tr>
                        </thead>
                        <tr v-for="(i,idx) in proyeccion_detalles" :key="idx">
                            <td class="text-center">
                                <select name="" id="" v-model="i.mp_tipos_id">
                                    <option v-for="mp in materias_primas" :key="mp.id" :value="mp.id">{{mp.nombre}}</option>
                                </select>
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.enero">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.febrero">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.marzo">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.abril">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.mayo">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.junio">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.julio">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.agosto">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.septiembre">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.octubre">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.noviembre">
                            </td>
                            <td class="text-center">
                                <input class="input-small" type="number" v-model="i.diciembre">
                            </td>
                            <td class="text-center">
                                <button class="btn thead-green1 btn-sm" @click="guardar(i,idx)">
                                    <i class="fas fa-save"></i> Guardar
                                </button>
                            </td>
                            <td class="text-center">
                                <button class="btn btn-danger btn-sm" @click="eliminar(i,idx)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        id:'',
        proyeccion:null,
        proyeccion_detalles:[],
        meses:['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'],
        materias_primas:[],
        errores:[],
        alert:false
    }),
    mounted(){
        this.id = this.$route.params.id;
        this.cargar_materias_primas();
    },
    methods:{
        async cargar_materias_primas(){
            await this.axios.get(`${this.api}/mps_tipo?limit=9999999`,this.cabeceras_json).then((res)=>{
                this.materias_primas = res.data.data.data;
            }).catch((e)=>{
                //console.log(e);
            });
            this.cargar();
        },
        async cargar(){
            await this.axios.get(`${this.api}/proyecciones/${this.id}`,this.cabeceras_json).then((res)=>{
                this.proyeccion = res.data.data;
                this.proyeccion_detalles = res.data.data.proyeccion_detalles;
                //console.log(res.data.data);
            }).catch((e)=>{
                //console.log(e);
            });
        },
        agregar(){
            this.proyeccion_detalles.push({
                id:null,
                proyecciones_id:this.id,
                mp_tipos_id:null,
                enero:null,
                febrero:null,
                marzo:null,
                abril:null,
                mayo:null,
                junio:null,
                julio:null,
                agosto:null,
                septiembre:null,
                octubre:null,
                noviembre:null,
                diciembre:null
            })
        },

        async eliminar(item,idx){
            if(item.id != null){
                await this.axios.delete(`${this.api}/proyeccion_detalles/${item.id}`,this.cabeceras_json).then((res)=>{
                    //console.log('eliminar',res.data);
                }).catch((e)=>{
                    //console.log(e);
                });
            }

            this.proyeccion_detalles.splice(idx,1);
            
        },
        async guardar(item,idx){
            if(item.id != null){
                await this.axios.put(`${this.api}/proyeccion_detalles/${item.id}`,item,this.cabeceras_json).then((res)=>{
                    //console.log('actualizar',res.data);
                    
                    if(res.data.codigo == 400){
                        this.errores = res.data.data;
                        this.alert = true;
                    }else{
                        this.$set(this.proyeccion_detalles[idx],'id',res.data.data.id);
                    }
                }).catch((e)=>{
                    //console.log(e);
                });
            }else{
                await this.axios.post(`${this.api}/proyeccion_detalles`,item,this.cabeceras_json).then((res)=>{
                    //console.log('crear',res.data);
                    if(res.data.codigo == 400){
                        this.errores = res.data.data;
                        this.alert = true;
                    }else{
                        this.$set(this.proyeccion_detalles[idx],'id',res.data.data.id);
                    }
                }).catch((e)=>{
                    //console.log(e);
                });
            }
            
        }
    },
    computed:{
        ...mapState(['api','cabeceras_json']),
        mensaje(){
            let devolver = [];
            Object.keys(this.errores).forEach(key => {
                  let array = this.errores[key];
                  array.forEach(mensaje => {
                      devolver.push(mensaje);
                  });
              });
            return devolver;
        },
    }
}
</script>
<style>
.input-small{
    max-width:80px !important;
}
.card .table td, .card .table th {
    padding-right: .5rem;
    padding-left: .5rem;
}
</style>